import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Store } from '@ngrx/store';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { IFolder } from 'src/app/shared/interfaces/folder/ifolder';
import { editFolder, saveFolder } from 'src/app/store/folder/folder.actions';

@Component({
  selector: 'app-dados-pastas-form',
  templateUrl: './dados-pastas-form.component.html',
  styleUrls: ['./dados-pastas-form.component.scss'],
})
export class DadosPastasFormComponent {
  funcionarioComAcesso: any[] = [
    { name: 'Ana Silva', code: 'F0' },
    { name: 'Roberta Lima', code: 'F1' },
    { name: 'Tiago Martins', code: 'F3' },
    { name: 'Fernanda Rocha', code: 'F4' },
  ];

  form: FormGroup = this.fb.group({
    name: ['', Validators.required],
    employees: [[], Validators.required],
  });
  id: number = 0;

  constructor(
    private fb: FormBuilder,
    private ref: DynamicDialogRef,
    private store: Store<IFolder>,
    private config: DynamicDialogConfig
  ) {}

  ngOnInit(): void {
    if (this.config.data && this.config.data.item) {
      this.id = this.config.data.item.id;
      this.popularFormulario(this.config.data.item);
    }
  }

  popularFormulario(item: IFolder) {
    this.form.controls['name'].setValue(item.name);
    this.form.controls['employees'].setValue(item.employees);
  }

  //functions
  saveForm() {
    const req: IFolder = {
      name: this.form.value.name,
      client: 1,
      employees: this.form.value.employees,
    };

    if (this.id) {
      this.store.dispatch(editFolder({ folder: req, id: this.id }));
    } else {
      this.store.dispatch(saveFolder({ folder: req }));
    }
    this.closeForm();
  }
  closeForm() {
    this.ref.close();
  }
}
